import { defineMessages } from 'react-intl';

const messages = defineMessages({
  previewLink: {
    description: 'Preview Emails',
    defaultMessage: 'Preview Emails',
    id: 'l+HtKL',
  },
});

export default messages;
